export enum COMMON_STATISTICS_SERVICE_LOCATION {
	CASE_MENU = 'case menu',
	CASE_CARD = 'case card',
	MAIN_MENU = 'main menu',
}
